import React, { Component } from "react";
import { connect } from "react-redux";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGrid, { SearchPanel, Paging, ColumnChooser, ColumnFixing, Editing, HeaderFilter, FilterPanel, FilterRow } from 'devextreme-react/data-grid';
import * as contractTypeCrud from "../../../../crud/contractType.crud";
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { injectIntl } from "react-intl";

class ContractTypes extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            contractTypes: null,
        };
    }

    componentDidMount() {
        this.fetchContractTypes();
    }
    
    fetchContractTypes = async () => {
        const response = await contractTypeCrud.getContractTypes();
        this.setState({ contractTypes: response.data });
    }

    onRowUpdating = async (e) => {
        const newObject = { ...e.oldData, ...e.newData };
        e.cancel = this.saveContractType(newObject);
    }
    saveContractType = (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                await contractTypeCrud.saveContractType(data);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }
    onRowRemoving = async (e) => {
        const deleteObj = { ...e.data };
        deleteObj.Deleted = 1;
        e.cancel = this.saveContractType(deleteObj);
    }
    onRowInserting = async (e) => {
        const newContractType = { ...e.data };
        e.cancel = this.createContractType(newContractType, e);
    }
    createContractType = (data, e) => {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await contractTypeCrud.saveContractType(data);
                e.data.ContractTypeID = resp.data.ContractTypeID;
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        })
    }
    onInitNewRow = async (e) => {
        e.data = { deleted: 0 };
    }
    render() {
        if (!this.state.contractTypes) {
            return <PortletSpinner />;
        }
        return (
            <Portlet>
                <PortletBody>
                    <DataGrid
                        dataSource={this.state.contractTypes}
                        keyExpr="ContractTypeID"
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        remoteOperations={false}
                        allowColumnReordering={true}
                        columnResizingMode='widget'
                        onContextMenuPreparing={this.addGridContextMenuItems}
                        onRowRemoving={this.onRowRemoving}
                        onRowUpdating={this.onRowUpdating}
                        onRowInserting={this.onRowInserting}
                        onInitNewRow={this.onInitNewRow}
                        columns={[
                            { caption: "Name", dataField: "Name", validationRules: [{ type: "required" }] },
                            { caption: "Cost Breakdown Quote", dataField: "CostBreakdownQuote"/*</PortletBody>, editorType: 'dxSwitch', editorOptions: { switchedOffText: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }), switchedOnText: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }) }*/ },
                            { caption: "Cost Breakdown Payment", dataField: "CostBreakdownPayment"/*</Portlet>, editorType: 'dxSwitch', editorOptions: { switchedOffText: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }), switchedOnText: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }) }*/ },
                            {
                                caption: "Create Date",
                                dataField: "CreateDate",
                                dataType: "date",
                                format: (date) => moment(date).format('DD/MM/YYYY'),
                                allowEditing: false,
                                visible: false
                            },
                        ]}
                    >
                        <Editing
                            mode="popup"
                            allowUpdating={true}
                            allowDeleting={true}
                            allowAdding={true}
                            confirmDelete={true}
                            popup={{ title: this.props.intl.formatMessage({ id: "SYSTEMSETTINGS.ADDEDIT.CONTRACTTYPE" }), height: 375, width: 600, showTitle: true }}
                            useIcons={true}
                            form={{
                                items: [
                                    { dataField: "Name", colSpan: 2 },
                                    { dataField: "CostBreakdownQuote", colSpan: 2 },
                                    { dataField: "CostBreakdownPayment", colSpan: 2 }
                                ]
                            }}
                        />
                        <HeaderFilter visible={true} />
                        <FilterPanel visible={true} />
                        <FilterRow applyFilter="auto" visible={true} />
                        <ColumnChooser enabled={true} />
                        <ColumnFixing enabled={true} />
                        <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                        <Paging pageSize={10} defaultPageSize={10} defaultPageIndex={0} />
                    </DataGrid>
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = (store) => ({
    userProfile: store.auth.userProfile
});

export default injectIntl(withSnackbar(connect(mapStateToProps, null)(ContractTypes)));